import { useAppDispatch, useAppSelector } from '../../useReduxToolkit';
import * as realtime from '../../../features/realtime/realtime.slice';
import { RealtimeMessageType } from '../../../features/realtime/realtime.types';
import {
  type ScreenshareEventData,
  ScreenshareRequestPayload,
} from '../screenshareState.types';
import { getCurrentRequestedMember } from '../../../features/screenshare/screenshare.selectors';
import { TrackedEvents } from '../../../features/tracking/track';
import { useTrack } from '../../useTrack';

export const useRejectScreenshareRequest = (): ((
  eventData?: ScreenshareEventData,
) => Promise<void>) => {
  const track = useTrack();
  const dispatch = useAppDispatch();
  const currentRequestedMemberId = useAppSelector(getCurrentRequestedMember);

  const rejectScreenshareRequest = async (
    eventData?: ScreenshareEventData,
  ): Promise<void> => {
    if (currentRequestedMemberId === undefined) {
      throw new Error(
        'Screenshare rejected but currentRequestedMemberId is undefined',
      );
    }
    await dispatch(
      realtime.sendMessage({
        id: currentRequestedMemberId,
        message: {
          messageType: RealtimeMessageType.ScreenshareRequest,
          payload: {
            eventName: ScreenshareRequestPayload.Reject,
            eventData,
          },
        },
      }),
    );

    void track(TrackedEvents.ButtonClicked, {
      button_action: 'Screenshare Rejected',
    });
  };

  return rejectScreenshareRequest;
};
